// extracted by extract-css-chunks-webpack-plugin
module.exports = {"parallaxEffect":"_3KVD8N"};